import FilterForm from 'assets/components/filters/filterForm/FilterForm';
import ThemeFilterFormDrawer from 'assets/components/filters/filterForm/themes/Theme.FilterForm.Drawer';
import Icon from 'assets/components/icon/Icon';
import SelectInput from 'assets/components/inputs/select/SelectInput';
import useApi from 'assets/hooks/api/useApi';
import { getLocales } from 'assets/locales/Locale';
import Distributor from 'models/sales/distributor/Model.Distributor';
import { useProductEnhancementDocumentProvider } from '../../ProductEnhancementDocument.Hooks';
import { useProductEnhancementDealerDocumentProvider } from '../ProductEnhancementDocument.DealerDocuments.Hooks';

export default function ProductEnhancementDocumentsDealerFilters() {
  const { lang } = getLocales();
  const { productEnhancementDocument } = useProductEnhancementDocumentProvider();
  const { dealerDocumentList } = useProductEnhancementDealerDocumentProvider();

  const distributorsApi = useApi({
    action: Distributor.list,
    wait: true,
    body: {
      productEnhancementId: productEnhancementDocument?.productEnhancementId
        ? [productEnhancementDocument.productEnhancementId]
        : undefined,
    },
  });

  return (
    <>
      <FilterForm
        subcomponents={ThemeFilterFormDrawer}
        filters={{ distributorId: dealerDocumentList.distributorId } as { distributorId?: number }}
        onReset={dealerDocumentList.resetFilters}
        onFilter={(newFilters) => dealerDocumentList.applyFilters(newFilters)}
        onOpen={() => {
          if (!distributorsApi.payload) distributorsApi.execute((body) => body);
        }}
        render={({ tempFilters, setFilters }) => {
          const distributors = distributorsApi?.payload?.data ?? [];

          return (
            <>
              <SelectInput
                name="distributorId"
                label={lang.distributors}
                data={distributors.map((item) => ({
                  ...item.displayInfo,
                  icon: <Icon class="fas-cloud" />,
                }))}
                isMultiselect={false}
                value={tempFilters?.distributorId}
                disabled={!distributors.length}
                onChange={({ distributorId }) => setFilters({ ...tempFilters, distributorId })}
                icon={<Icon class="fas-cloud" />}
              />
            </>
          );
        }}
      />
    </>
  );
}
